import { useEffect, useRef } from "react"; // Import useRef
import { useNavigate } from "react-router-dom";
import AuthService from "../services/AuthService";
import { useUser } from "../contexts/UserContext";

const UserLogout = () => {
  const navigate = useNavigate();
  const { setUser } = useUser();

  // Create a ref to track if logout has been initiated
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    // Only run the logout logic if it hasn't been run before
    if (!hasLoggedOut.current) {
      const performLogout = async () => {
        try {
          await AuthService.logout(); // clear session/token
        } catch (error) {
          // We still log the error, but we expect a 401 on the second run
          console.error(
            "Logout request failed (this is expected in Strict Mode):",
            error
          );
        } finally {
          setUser(null); // clear user context
          navigate("/login");
        }
      };

      performLogout();

      // Set the ref to true so this effect doesn't run again
      hasLoggedOut.current = true;
    }
  }, [navigate, setUser]); // Dependencies can remain the same

  return null; // This component doesn't render anything
};

export default UserLogout;
